import React from "react";

import classNames from "classnames";
import { Button, CloseButton, Modal } from "react-bootstrap";

import { useMyScheduleModalContext } from "../contexts/Modal";
import { useButtonHandlers } from "../hooks/useButtonHandlers";
import { dateFormat } from "../lib/dateFormat";

import Loading from "../../../../components/Loading";
import { capitalize } from "lodash";

const MyScheduleModal = () => {
    const {
        showModal,
        setShowModal,
        modalContent,
        modalRequestStatus,
        modalStatusMessage,
        setModalStatusMessage,
        setModalRequestStatus,
    } = useMyScheduleModalContext();

    const { handleModalConfirmClick } = useButtonHandlers();
    const { game, umpireId, type } = modalContent ?? {};

    let modalHeader = "";

    switch (type) {
        case "requestreplacement":
            modalHeader = "Do you wish to request a replacement for this game?";
            break;
        case "cancelreplacement":
            modalHeader = "Do you wish to cancel this replacement request?";
            break;
        case "cancelbooking":
            modalHeader = "Do you wish to cancel this booking?";
            break;
    }

    const umpireLocation = game?.umpires?.find(
        u => u.id === umpireId,
    )?.location;

    const handleClose = () => {
        setModalRequestStatus(undefined);
        setShowModal(false);
        setModalStatusMessage("");
    };

    return (
        <Modal
            className={classNames("myScheduleModal")}
            centered
            show={showModal}
            onHide={handleClose}
        >
            <Modal.Header>
                <h4>{modalHeader}</h4>
                <CloseButton onClick={handleClose} />
            </Modal.Header>
            <Modal.Body>
                {game && (
                    <>
                        {type === "requestreplacement" && (
                            <h5
                                className={classNames(
                                    "text-danger",
                                    "text-center",
                                )}
                            >
                                Posting a game for replacement does not relieve
                                you from the responsibility to officiate the
                                game if no replacement is found.
                            </h5>
                        )}
                        <dl className={classNames("inline")}>
                            <dt>Date:</dt>
                            <dd>{dateFormat.format(new Date(game.date))}</dd>
                            <dt>Age Level:</dt>
                            <dd>{game.ageLevel.ageLevel}</dd>
                            <dt>
                                {game.site === 1 ? "League:" : "Tournament:"}
                            </dt>
                            <dd>{game.leagueName}</dd>
                            {game.site === 1 && (
                                <>
                                    <dt>Teams:</dt>
                                    <dd>
                                        {`${game.visitor.name || "TBD"} @ ${game.home.name || "TBD"}`}
                                    </dd>
                                </>
                            )}
                            <dt>Location:</dt>
                            <dd>{game.fieldName}</dd>
                            {game.diamond && (
                                <>
                                    <dt>Diamond:</dt>
                                    <dd>{game.diamond}</dd>
                                </>
                            )}
                            {game.note && (
                                <>
                                    <dt>Game/Field Note:</dt>
                                    <dd>{game.note}</dd>
                                </>
                            )}
                            {game.site === 1 && (
                                <React.Fragment>
                                    <dt>Umpire Position:</dt>
                                    <dd>{capitalize(umpireLocation)}</dd>
                                </React.Fragment>
                            )}
                        </dl>
                    </>
                )}
                {modalRequestStatus === "pending" && <Loading />}
                <h4
                    className={classNames({
                        statusMessage: true,
                        modalRequestStatus: true,
                        "text-primary": modalRequestStatus === "success",
                        "text-danger": modalRequestStatus === "failed",
                        "d-none":
                            !modalRequestStatus ||
                            modalRequestStatus === "pending",
                    })}
                >
                    {modalStatusMessage}
                </h4>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="danger"
                    onClick={handleClose}
                    disabled={modalRequestStatus === "pending"}
                >
                    {modalRequestStatus === "success" ||
                    modalRequestStatus === "failed"
                        ? "Close"
                        : "No"}
                </Button>
                {modalRequestStatus !== "success" &&
                    modalRequestStatus !== "failed" && (
                        <Button
                            variant="primary"
                            disabled={modalRequestStatus === "pending"}
                            onClick={() =>
                                game &&
                                umpireId &&
                                handleModalConfirmClick({
                                    game,
                                    umpireId,
                                    type,
                                })
                            }
                        >
                            Yes
                        </Button>
                    )}
            </Modal.Footer>
        </Modal>
    );
};

export default MyScheduleModal;
